module.exports = __webpack_public_path__ + "static/media/swingDividing_pattern.bf88f7b3.png";